<template>
  <div class="login-page">
    <div class="login-box shadow">
      <div class="text-center mb-4">
        <img src="frontend/img/logo/logo.png" alt="Logo" width="60" />
        <h3 class="mt-3">Employee Login</h3>
      </div>
      <form @submit.prevent="login">
        <div class="mb-3">
          <label for="email" class="form-label">Email address</label>
          <input
            type="email"
            class="form-control"
            id="email"
            v-model="email"
            placeholder="Enter email"
            required
          />
        </div>
        <div class="mb-4">
          <label for="password" class="form-label">Password</label>
          <input
            type="password"
            class="form-control"
            id="password"
            v-model="password"
            placeholder="Enter password"
            required
          />
        </div>
        <button type="submit" class="btn btn-primary w-100">Login</button>
        <div v-if="error" class="alert alert-danger mt-3">{{ error }}</div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: "EmployeeLogin",
  data() {
    return {
      email: "",
      password: "",
      error: null,
    };
  },
  methods: {
    async login() {
      this.error = null;
      try {
        const response = await fetch("http://localhost:3333/login", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email: this.email, password: this.password }),
        });

        const data = await response.json();

        if (!response.ok) throw new Error(data.message || "Login failed");

        localStorage.setItem("token", data.token);
        this.$router.push("/"); // Redirect after login
      } catch (err) {
        this.error = err.message;
      }
    },
  },
};
</script>

<style scoped>
.login-page {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #070642, #240556);
  padding: 20px;
}

.login-box {
  background: white;
  padding: 30px;
  border-radius: 15px;
  width: 100%;
  max-width: 400px;
  animation: fadeIn 0.8s ease-in-out;
}

.login-box h3 {
  font-weight: 700;
  color: #240556;
}

.btn-primary {
  background-color: #240556;
  border-color: #240556;
  font-weight: 600;
}

.btn-primary:hover {
  background-color: #070642;
  border-color: #070642;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
